import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["linksList", "addButton", "form", "urlInput", "titleInput", "hiddenField"]

  connect() {
    this.links = JSON.parse(this.hiddenFieldTarget.value || "[]")
  }

  showForm() {
    this.formTarget.classList.remove("hidden")
    this.addButtonTarget.classList.add("hidden")
    this.formTarget.querySelector('input')?.focus()
  }

  hideForm() {
    this.formTarget.classList.add("hidden")
    this.addButtonTarget.classList.remove("hidden")
    this.urlInputTarget.value = ""
    this.titleInputTarget.value = ""
  }

  handleSubmit(event) {
    event.preventDefault()

    const url = this.urlInputTarget.value.trim()
    const title = this.titleInputTarget.value.trim()

    if (!url) {
      this.urlInputTarget.focus()
      return
    }

    // Add the new link to the array
    this.links.push({ url, title })
    this.updateHiddenField()
    this.renderLinks()

    // Clear and refocus
    this.clearForm()

    // Now submit the form for real (this will send the PATCH request)
    this.formTarget.requestSubmit()
  }

  addLink(event) {
    event?.preventDefault()
    // Trigger form submission
    this.formTarget.requestSubmit()
  }

  clearForm() {
    this.urlInputTarget.value = ""
    this.titleInputTarget.value = ""
    this.urlInputTarget.focus()
  }

  removeLink(event) {
    const index = parseInt(event.currentTarget.dataset.index)
    this.links.splice(index, 1)
    this.updateHiddenField()
    this.renderLinks()
    this.submitForm()
  }

  updateHiddenField() {
    this.hiddenFieldTarget.value = JSON.stringify(this.links)
  }

  submitForm() {
    this.formTarget.requestSubmit()
  }

  renderLinks() {
    this.linksListTarget.innerHTML = this.links.map((link, index) => `
      <div class="group flex items-center justify-between py-1 hover:bg-surface rounded px-1 -mx-1">
        <a href="${this.escapeHtml(link.url)}" target="_blank" class="text-accent hover:text-accent-hover truncate flex-1">
          ${this.escapeHtml(link.title || link.url)}
        </a>
        <button type="button"
          class="opacity-0 group-hover:opacity-100 text-danger hover:text-danger-hover ml-2"
          data-action="click->task-links#removeLink"
          data-index="${index}">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    `).join("")
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
